import { useCallback, useState } from 'react';

export const useBoolean = (initialSate?: boolean) => {
  const [bol, setBol] = useState(initialSate || false);

  const handleToggle = useCallback<{ (newState?: boolean): void }>(newState => {
    setBol(prevState => (typeof newState === 'undefined' ? !prevState : newState));
  }, []);

  return [bol, handleToggle] as const;
};
